import { SvgIcon, SvgIconProps } from '@mui/material'

export function EyeHidden(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.292 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 1 1-1.414 1.414l-2.963-2.963c-1.61.753-3.453 1.266-5.33 1.256-2.766-.015-5.46-1.156-7.443-2.508-.998-.68-1.851-1.437-2.468-2.177C1.512 14.622 1 13.775 1 12.933c0-.436.137-.87.313-1.255.18-.397.433-.81.734-1.218.601-.819 1.442-1.688 2.435-2.483.375-.3.779-.595 1.205-.875L2.292 3.707a1 1 0 0 1 0-1.414ZM7.135 8.55c-.493.302-.964.635-1.403.987-.876.702-1.59 1.448-2.074 2.107-.242.33-.416.621-.525.862-.115.252-.133.39-.133.426 0 .104.11.484.626 1.102.474.57 1.18 1.207 2.056 1.804 1.763 1.202 4.073 2.15 6.328 2.16 1.287.008 2.59-.293 3.799-.775l-1.834-1.834a3.5 3.5 0 0 1-4.865-4.865L7.135 8.551Zm3.45 3.45 1.915 1.914A1.5 1.5 0 0 1 10.586 12ZM12.005 7a6.95 6.95 0 0 0-.758.042L9.555 5.331A9.6 9.6 0 0 1 12.005 5c2.835 0 5.55 1.382 7.516 2.95.993.791 1.833 1.66 2.435 2.483.566.774 1.044 1.674 1.044 2.5 0 .85-.503 1.707-1.083 2.413-.324.395-.714.792-1.157 1.18l-1.418-1.418a8.4 8.4 0 0 0 1.03-1.032c.509-.619.628-1.014.628-1.143 0-.154-.14-.61-.658-1.32-.483-.66-1.193-1.402-2.067-2.1C16.508 8.106 14.223 7 12.005 7Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default EyeHidden
